module.exports = __webpack_public_path__ + "static/media/waitingContainer.a9f7ca6e.svg";